import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config";
import axiosClient from "../../../common/api/request";

// A 500 or a body that is not an object reads as the request's own message,
// the same rule the report downloads use for their error toasts.
const toRejectValue = (error) =>
  error?.response?.data &&
  typeof error.response.data === "object" &&
  error?.response?.status !== 500
    ? error.response.data
    : { Error: error?.message };

const createDailyOrdersThunk = (endpoint) =>
  createAsyncThunk(
    `dailyOrdersV3/${endpoint}`,
    async (params, { rejectWithValue }) => {
      try {
        return await axiosClient.get(
          `${config.API_URL_V3}/daily_orders/${endpoint}/`,
          { params }
        );
      } catch (error) {
        return rejectWithValue(toRejectValue(error));
      }
    }
  );

export const getDailyOrdersSummary = createDailyOrdersThunk("summary");
export const getDailyOrdersDaily = createDailyOrdersThunk("daily");
export const getDailyOrdersWeekday = createDailyOrdersThunk("weekday");
export const getDailyOrdersHours = createDailyOrdersThunk("hours");
export const getDailyOrdersBreakdowns = createDailyOrdersThunk("breakdowns");
export const getDailyOrdersDetails = createDailyOrdersThunk("details");
export const getDailyOrdersInsights = createDailyOrdersThunk("insights");
export const getDailyOrdersInsightsHourly =
  createDailyOrdersThunk("insights/hourly");
export const getDailyOrdersInsightsBreakdowns = createDailyOrdersThunk(
  "insights/breakdowns"
);
export const getDailyOrdersInsightsCustomers =
  createDailyOrdersThunk("insights/customers");
export const downloadDailyOrders = createDailyOrdersThunk("download");
